import type { ReactNode } from 'react'
import { Button, Icon } from '@chakra-ui/react'
import { faPlus } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CustomTooltip from 'BrokerTsLib/src/components/CustomTooltip'

import { SectionCard } from './components/SectionCard'

export const IndexaceSection = ({ count, canApplyDiscount, disabledReasons, onApplyClick, children }: {
  count: number
  canApplyDiscount: boolean
  disabledReasons: string[]
  onApplyClick: () => void
  children: ReactNode
}) => {
  const button = (
    <Button
      variant="outline"
      size="sm"
      leftIcon={<Icon as={FontAwesomeIcon} icon={faPlus} />}
      onClick={onApplyClick}
      isDisabled={!canApplyDiscount}
    >
      Mimořádná sleva
    </Button>
  )

  return (
    <SectionCard
      title="Indexace"
      count={count}
      action={
        !canApplyDiscount && disabledReasons.length > 0
          ? <CustomTooltip label={disabledReasons.join(' ')} hasArrow>{button}</CustomTooltip>
          : button
      }
    >
      {children}
    </SectionCard>
  )
}
